export default {
  data () {
    return {
      datePickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            let d = new Date()
            picker.$emit('pick', [d, d]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            let d = new Date();
            d.setTime(d.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [d, d]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DatePickerOptions.js